export default __webpack_public_path__ + "static/media/adventure-activity.d52ed5f8.svg";